module.exports = __webpack_public_path__ + "static/pic02-a8023c9e744581bdcb5c07979dfe54e8.jpg";